import React from 'react';
import CTAButton from '../../components/CTAButton/CTAButton';
import ProjectPage from '../../components/ProjectPage/ProjectPage';
import YouTubeEmbed from '../../components/YouTubeEmbed/YouTubeEmbed';
// import { useAAAIDPAnimationInfo } from '../../content/projects/aaa-idp-animation.project';
import { useTBMAnimationInfo } from '../../content/projects/tbm-animation.project';
import { PageComponent } from '../../types/gatsby.types';
// import './ProjectPageJimOCallaghan.scss';

type ProjectPageTBMAnimationProps = {}

const ProjectPageTBMAnimation: PageComponent<ProjectPageTBMAnimationProps> = props => {
  const metaInfo = useTBMAnimationInfo();
  return <ProjectPage
    {...props} // always include
    project={metaInfo}
    sidebarExtraContent={
      <CTAButton to="https://www.youtube.com/watch?v=nD1nExGxVNQ&t=6s" title="Watch on YouTube" target="_blank" ribbons drawLine="left">Watch on YouTube</CTAButton>
    }
  >
    <YouTubeEmbed
      src="https://www.youtube.com/embed/nD1nExGxVNQ"
      title="CPD Video Player"
    />
  </ProjectPage>
}

export default ProjectPageTBMAnimation;